module.exports = __webpack_public_path__ + "static/media/ramalhos_brasil.17f8163e.webp";